import React, { FC } from 'react';

import { AvailabilityInput } from './AvailabilityInput';
import { ShowAvailabilityCheckbox } from './ShowAvailabilityCheckbox';

const SchedulePermanent: FC = (): React.ReactElement => {
  return (
    <div className="flex flex-col gap-5 w-full">
      <AvailabilityInput id="availability" className="w-[140px]" />
      <ShowAvailabilityCheckbox />
      <p className="text-sm text-zinc-500">
        Permanent events won't have an end date
      </p>
    </div>
  );
};

export { SchedulePermanent };
